import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedInitData} from '@nolimitcity/slot-game/bin/core/server/data/ParsedInitData';
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IResizeData} from '@nolimitcity/slot-game/bin/core/stage/StageManager';
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BarbarianFurySoundConfig} from '../../BarbarianFurySoundConfig';
import {BFGameEvent} from "../../events/BFGameEvent";
import {BarbarianFuryGameMode} from "../../gamemode/BarbarianFuryGameMode";

export class BFFreespinIntroView extends ScreenView {
    private _furySpins:PIXI.Sprite;
    private _fsCount:PIXI.BitmapText;
    private _scatterIntroImg:PIXI.Sprite;
    private _fs_intro_wild:PIXI.Sprite;
    private _mSymImgInIntro:PIXI.Sprite;
    private _introSprite:PIXI.Sprite;
    private _introContainer:PIXI.Container;

    constructor(config:IScreenViewConfig, autoClose?:boolean) {
        super(config, autoClose);
    }

    /**
     * override this funciton to initialize images for intro
     * setting their visibility false
     */
    protected initAnimations():void {
        super.initAnimations();
        this._introContainer = new PIXI.Container();
        (this._furySpins = new PIXI.Sprite(GameResources.getTextures("fs_fury_text")[0])).visible = false;
        (this._scatterIntroImg = new PIXI.Sprite(GameResources.getTextures("scatter_fs")[0])).visible = false;
        (this._mSymImgInIntro = new PIXI.Sprite(GameResources.getTextures("fs_m")[0])).visible = false;
        (this._fs_intro_wild = new PIXI.Sprite(GameResources.getTextures("fs_intro_wild")[0])).visible = false;
        this.addChild(this._introContainer);
        this._fsCount = new PIXI.BitmapText("0", {
            fontName : "NumbersWinCountUp",
            fontSize : 20
        });
        this._fsCount.visible = false;
        this._introContainer.addChild(this._furySpins, this._scatterIntroImg, this._mSymImgInIntro, this._fs_intro_wild, this._furySpins);
    }

    /**
     * override this function to play fs loop
     * when intro continue button is pressed
     */
    protected onButtonClick():void {
        super.onButtonClick();
        SlotGame.sound.playAmbience(BarbarianFurySoundConfig.instance.FREE_GAME_AMBIANCE);
    }

    /**
     * override this function add Backgroung in Intro
     * setting anchor of bg.
     */
    protected createBackground():PIXI.DisplayObject {
        this._introSprite = new PIXI.Sprite(GameResources.getTextures("bonusBackground")[0]);
        this._introSprite.anchor.set(0.5);
        this._introSprite.visible = false;
        return this._introSprite;
    }

    /**
     * override this function to resize background
     * and other elements of intro
     * @param resizeData
     */
    protected onResize(resizeData:IResizeData):void {
        super.onResize(resizeData);

        this.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        this._background.position.set(NolimitApplication.screenBounds.width * 0.5, NolimitApplication.screenBounds.height * 0.5);
        this.scale.set(1);

        this._scatterIntroImg.anchor.set(0.5);
        this._furySpins.anchor.set(0.5);
        this._mSymImgInIntro.anchor.set(0.5);
        this._fs_intro_wild.anchor.set(0.5);
        this._introSprite.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        this._fsCount.pivot.set(this._fsCount.width / 2, this._fsCount.height / 2);

        this._fsCount.position.set(this._screenWidth / 2, this._screenHeight * 0.2 - this._fsCount.height);
        this._furySpins.position.set(this._screenWidth * 0.51, this._screenHeight * 0.21);
        if(resizeData.orientation === "landscape") {
            this._introContainer.y = 0;
            this._mSymImgInIntro.scale.set(0.74);
            this._scatterIntroImg.scale.set(1);
            this._fs_intro_wild.scale.set(1);
            this._scatterIntroImg.position.set(this._screenWidth * 0.2, this._screenHeight * 0.45);
            this._mSymImgInIntro.position.set(this._screenWidth * 0.5, this._screenHeight * 0.55);
            this._fs_intro_wild.position.set(this._screenWidth * 0.8, this._screenHeight * 0.45);
        } else {
            //this.y = -280; // temporary fix of resizing just for dev. purpose.
            this._introContainer.y = -50;
            this._fsCount.position.set(this._screenWidth / 2, this._screenHeight * 0.2 - this._fsCount.height);
            this._scatterIntroImg.scale.set(0.8);
            this._scatterIntroImg.position.set(this._screenWidth * 0.2, this._screenHeight * 0.3);
            this._mSymImgInIntro.scale.set(1);
            this._mSymImgInIntro.position.set(this._screenWidth * 0.5, this._screenHeight * 0.6);
            this._fs_intro_wild.scale.set(0.8);
            this._fs_intro_wild.position.set(this._screenWidth * 0.8, this._screenHeight * 0.3);

            if(resizeData.bottom <= 730) {
                // fix for 4:3 ratio
                this._mSymImgInIntro.scale.set(0.8);
            }
        }
    }

    /**
     * override this funciton set visibility of elements
     * calculate count for free spins
     * Fade out keypad on Restore.
     * @param data
     * @param onShowComplete
     */
    protected startPresentation(data?:ParsedServerData, onShowComplete?:() => void):void {
        super.startPresentation(data, onShowComplete);
        SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.FS_INTRO);
        (data as ParsedInitData).isRestoreState && SlotGame.keypad.hide(); // on restore
        this._fsCount.text = (data!.freespinsLeft).toString();
        this._fsCount.pivot.set(this._fsCount.width / 2, this._fsCount.height / 2);
        this._fsCount.position.set(this._screenWidth / 2, this._screenHeight * 0.2 - this._fsCount.height);
        this._introContainer.addChild(this._fsCount);
        this._fsCount.visible = true;
        this._introSprite.visible = true;
        this._furySpins.visible = true;
        this._scatterIntroImg.visible = true;
        this._mSymImgInIntro.visible = true;
        this._fs_intro_wild.visible = true;
    }

    /**
     * override this function to change visibility on Backgrounds
     * hide keypad on restore
     * @param closeCallback
     */
    protected stopPresentation(closeCallback?:() => void):void {
        super.stopPresentation(closeCallback);

        this._introSprite.visible = false;
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : BarbarianFuryGameMode.FREESPIN}));
        EventHandler.dispatchEvent(new GameEvent(BFGameEvent.ENTER_FREESPIN));

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
    }

    /**
     * override this function to change position of continue button
     * @param data
     */
    protected setButtonPosition(data:IResizeData):void {
        super.setButtonPosition(data);
        //fix done for Continue button for Russian
        //this._button.scale.set(0.8);
        this._button.setSize(307, 82, 0.8);
        this._button.position.set(this._screenWidth * 0.5, this._screenHeight * 0.89);
    }
}